<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0"
             role="tabpanel" style="height: 500px;">
        <div class="row">
            <div class="col-md-4 m-t-5">
                <div class="ml-auto d-flex no-block align-items-center float-left">
                    <div>
                        <h4 class="font-medium m-b-0 text-info" v-if="contract.amount">{{contract.amount | money}}</h4>
                        <span>Contract Amount</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4 m-t-5">
                <div class="ml-auto d-flex no-block align-items-center float-center">
                    <div>
                        <h4 :class="{'text-danger':contract.due.amount>0}" class="font-medium m-b-0 text-info"
                            v-if="contract.due">{{contract.due | money}}</h4>
                        <span>Amount Due</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4 m-t-5">
                <div class="ml-auto d-flex no-block align-items-center float-right">
                    <div class="dl">
                        <div class="button-group">
                            <a @click="reset" class="btn btn-success waves-effect waves-light text-white"
                               data-target="#myModal" data-toggle="modal">
                                <i class="fas fa-plus"></i> Add Payment Terms
                            </a>
                        </div>
                    </div>
                </div>

                <!-- MODAL FOR ADDING PAYMENT TERMS -->
                <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="myModal" role="dialog"
                     tabindex="-1">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <form @submit.prevent="handleSubmit">
                                <div class="modal-header">
                                    <h4 class="modal-title" id="myModalLabel">Payment Terms</h4>
                                    <button @click="reset()" aria-hidden="true" class="close" data-dismiss="modal"
                                            type="button">×
                                    </button>
                                </div>
                                <div class="modal-body card-blue">
                                    <div class="card-body">
                                        <div class="col-sm-12 col-lg-10">
                                            <div class="form-group row">
                                                <label class="col-sm-4 text-right control-label col-form-label"
                                                       for="method">Select Method</label>
                                                <div class="col-sm-7">
                                                    <multiselect
                                                        :class="{'is-invalid': submitted && errors.has('method')}"
                                                        :options="paymentMethods"
                                                        @input="selectPaymentMethod"
                                                        class="form-control"
                                                        data-vv-as="Method"
                                                        id="method"
                                                        label="name"
                                                        name="method"
                                                        placeholder="Choose Payment Term Method"
                                                        track-by="id"
                                                        v-model="paymentTerm.method"
                                                        v-validate="'required'">
                                                        <span class="multiselect__placeholder">Type to search</span>
                                                    </multiselect>
                                                    <div class="invalid-feedback"
                                                         v-if="submitted && errors.has('method')">{{
                                                            errors.first('method') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-lg-10 m-t-20">
                                            <div class="form-group row">
                                                <label class="text-right col-sm-4 control-label col-form-label">Amount</label>
                                                <div class="input-group col-sm-7">
                                                    <input :class="{'is-invalid': submitted && errors.has('amount')}"
                                                           class="form-control"
                                                           data-vv-as="amount"
                                                           id="amount"
                                                           name="amount"
                                                           placeholder="Input Amount"
                                                           style="width: 250px; height: 42px;"
                                                           type="text"
                                                           v-model="paymentTerm.amount"
                                                           v-validate="'required'">
                                                    <div class="invalid-feedback"
                                                         v-if="submitted && errors.has('amount')">{{
                                                            errors.first('amount') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-lg-10">
                                            <div class="form-group row">
                                                <label class="text-right col-sm-4 control-label col-form-label"
                                                       for="issue_at">Effective From</label>
                                                <div class="input-group col-sm-7">
                                                    <div class="input-group-prepend date">
                                                        <span class="input-group-text"><i
                                                            class="fa fa-calendar"></i></span>
                                                    </div>
                                                    <input :class="{'is-invalid': submitted && errors.has('issue_at')}"
                                                           autocomplete="off"
                                                           class="form-control"
                                                           data-vv-as="issue_at"
                                                           id="issue_at"
                                                           name="issue_at"
                                                           placeholder="dd/mm/yyyy"
                                                           type="text"
                                                           v-model="paymentTerm.issue_date"
                                                           v-validate="'required'">
                                                    <div class="invalid-feedback"
                                                         v-if="submitted && errors.has('issue_at')">{{
                                                            errors.first('issue_at') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-lg-10">
                                            <div class="form-group row">
                                                <label class="text-right col-sm-4 control-label col-form-label"
                                                       for="due_at">Due Date</label>
                                                <div class="input-group col-sm-7">
                                                    <div class="input-group-prepend date">
                                                        <span class="input-group-text"><i
                                                            class="fa fa-calendar"></i></span>
                                                    </div>
                                                    <input :class="{'is-invalid': submitted && errors.has('due_at')}"
                                                           autocomplete="off"
                                                           class="form-control"
                                                           data-vv-as="due_at"
                                                           id="due_at"
                                                           name="due_at"
                                                           placeholder="mm/dd/yyyy"
                                                           type="text"
                                                           v-model="paymentTerm.due_date"
                                                           v-validate="'required'">
                                                    <div class="invalid-feedback"
                                                         v-if="submitted && errors.has('due_at')">{{
                                                            errors.first('due_at') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-if="selectedPaymentMethod === 'Recurring'">
                                            <div class="col-sm-12 col-lg-10 m-t-20">
                                                <div class="form-group row">
                                                    <label class="text-right col-sm-4 control-label col-form-label">Frequency</label>
                                                    <div class="input-group col-sm-5">
                                                        <multiselect
                                                            :class="{'is-invalid': submitted && errors.has('frequency')}"
                                                            :options="frequencies"
                                                            class="form-control"
                                                            data-vv-as="frequency"
                                                            id="frequency"
                                                            label="name"
                                                            name="frequency"
                                                            placeholder="Choose Period of Payment"
                                                            track-by="id"
                                                            v-model="paymentTerm.frequency"
                                                            v-validate="'required'">
                                                            <span class="multiselect__placeholder">Type to search</span>
                                                        </multiselect>
                                                        <div class="invalid-feedback"
                                                             v-if="submitted && errors.has('frequency')">{{
                                                                errors.first('frequency') }}
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-2" style="margin-top: 4px">
                                                        <button @click="calculateInstallment"
                                                                class="btn btn-primary waves-effect waves-light"
                                                                type="button">Calculate
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="dataTables_scroll" style="margin-top: 45px"
                                             v-if="installment.length >0">
                                            <div class="dataTables_scrollHead"
                                                 style="position: relative; overflow: auto; max-height: 218px; width: 100%;">
                                                <table class="table table-striped display dataTable" role="grid"
                                                       style="width: 100%; margin-bottom: -1px;">
                                                    <thead>
                                                    <tr>
                                                        <th><h6>#</h6></th>
                                                        <th style="width: 255px;"><h6>Due Date</h6></th>
                                                        <th style="width: 245px;"><h6>Amount</h6></th>
                                                    </tr>
                                                    </thead>
                                                </table>
                                                <!--</div>-->
                                            </div>
                                            <div class="dataTables_scrollBody"
                                                 style="position: relative; overflow: auto; max-height: 218px; width: 100%;">
                                                <table aria-describedby="scroll_ver_info"
                                                       class="table table-striped display dataTable" id="scroll_ver"
                                                       role="grid" style="width: 100%;">
                                                    <tbody>
                                                    <tr v-bind:key="index" v-for="(i, index) in installment">
                                                        <td>{{index+1}}</td>
                                                        <td style="width: 262px;">{{i.due_date | date}}</td>
                                                        <td style="width: 232px;">{{i.amount | money}}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer button-group">
                                    <button class="btn btn-success waves-effect waves-light text-white" type="submit">
                                        Add
                                    </button>
                                    <a @click="reset" class="btn btn-secondary waves-effect waves-light text-white">Reset</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TABLE FOR ADDED PAYMENT TERMS -->
            <div class="col-md-12 m-t-20" v-if="this.contract.paymentTerms.length > 0">
                <div class="table-responsive">
                    <table class="table no-wrap v-middle">
                        <thead>
                        <tr class="border-0">
                            <th class="border-0"><h6>#</h6></th>
                            <th class="border-0"><h6>Terms Type</h6></th>
                            <th class="border-0"><h6>Amount</h6></th>
                            <th class="border-0"><h6>Effective From</h6></th>
                            <th class="border-0"><h6>Due at</h6></th>
                            <th class="border-0"><h6>Frequency</h6></th>
                            <th class="border-0"><h6>Action</h6></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-bind:key="index" v-for="(pt, index) in contract.paymentTerms">
                            <td>{{index+1}}</td>
                            <td>{{pt.type.name}}</td>
                            <td>{{pt.amount | money}}</td>
                            <td>{{pt.effective_from}}</td>
                            <td>{{pt.due_at}}</td>
                            <td v-if="pt.type.id === 2">{{pt.frequency.name}}(No. of Installment: {{pt.no_of_emi}})</td>
                            <td v-else>One Time</td>
                            <td>
                                <a @click="setRemoveIndex(index)" class="text-danger" data-target="#confirmModal"
                                   data-toggle="modal" href="javasript:void(0);">
                                    <b>Remove</b>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal"
                         role="dialog" tabindex="-1">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body card-blue">
                                    <div class="text-center m-t-20 m-b-10">
                                        <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                                        <br><br>
                                        <h4>Are you sure you want to remove this payment term?</h4>
                                        <button @click="removePaymentTerm(removeIndex)"
                                                class="btn waves-effect waves-light btn-success m-r-15"
                                                data-dismiss="modal" type="button">Yes
                                        </button>
                                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal"
                                                type="button">No
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {mapGetters} from "vuex";
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import Money from "../../../../../models/Money";

export default {
    name: "PaymentTerm",
    computed: {
        ...mapGetters(["currentUser", "currentOrg"])
    },
    components: {Multiselect},
    data() {
        return {
            submitted: false,
            isForward: false,
            calculated: false,
            paymentTerm: {
                method: null,
                currency: null,
                amount: null,
                issue_date: null,
                due_date: null,
                frequency: null
            },
            issue_date: null,
            due_date: null,
            contract: this.$parent.contract,
            paymentMethods: [
                {
                    id: 1,
                    name: 'Single'
                },
                {
                    id: 2,
                    name: 'Recurring'
                }
            ],
            frequencies: [
                {
                    id: 1,
                    name: 'Monthly'
                },
                {
                    id: 2,
                    name: 'Quarterly'
                },
                {
                    id: 3,
                    name: 'Yearly'
                }],
            from: null,
            to: null,
            currency_symbol: '',
            selectedPaymentMethod: '',
            installment: [],
            removeIndex: null
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        async init() {
            jQuery('#issue_at').datepicker({
                autoclose: true,
                todayHighlight: true
            }).on('change', (event) => {
                this.issue_date = event.target.value;
                this.paymentTerm.issue_date = moment(event.target.value).format('DD/MM/YYYY');
            });
            jQuery('#due_at').datepicker({
                autoclose: true,
                todayHighlight: true
            }).on('change', (event) => {
                this.due_date = event.target.value;
                this.paymentTerm.due_date = moment(event.target.value).format('DD/MM/YYYY');
            });
            this.expressid = this.currentOrg.express_id;
            // if(this.contract.due.currency_id !== this.contract.amount.currency_id) {
            //     this.contract.paymentTerms = [];
            //     this.contract.due          = this.contract.amount;
            // }
            this.contract.amount.amount = 0;
            this.contract.items.forEach(ci => {
                this.contract.amount.amount = Number(this.contract.amount.amount) + (Number(ci.quantity) * Number(ci.rate));
            });
            this.contract.amount.currency_id = this.currentOrg.currency_id;
            this.contract.amount.currency_name = this.currentOrg.currency_name;
            this.contract.amount.currency_symbol = this.currentOrg.currency_symbol;
            if (this.contract.due.amount === null) {
                this.contract.due = this.contract.amount;
            } else {
                this.contract.due = {
                    amount: Number(this.contract.amount.amount) - Number(this.calculateAddedPaymentTerm(this.contract.paymentTerms, {amount: 0}).amount),
                    currency_id: this.currentOrg.currency_id,
                    currency_name: this.currentOrg.currency_name,
                    currency_symbol: this.currentOrg.currency_symbol
                };
            }
        },
        async handleSubmit() {
            this.submitted = true;
            try {
                let valid = await this.$validator.validate();
                if (valid) {
                    this.submitted = false;
                    this.addPaymentTerm();
                }
            } catch (e) {
                console.error(e);
            }
        },
        selectPaymentMethod() {
            this.installment = [];
            this.selectedPaymentMethod = this.paymentTerm.method.name;
        },
        calculateInstallment() {
            this.calculated = true;
            this.from = moment(this.paymentTerm.issue_date, 'DD/MM/YYYY');
            this.to = moment(this.paymentTerm.due_date, 'DD/MM/YYYY');
            this.installment = [];
            /** If Frequency Type is MONTHLY **/
            if (this.paymentTerm.frequency.id === 1) {
                let month_diff = Number(this.to.diff(this.from, "months"));
                if (month_diff > 0) {
                    let amount = this.paymentTerm.amount;
                    let next;
                    if (Number(this.from.format('M')) === 12) {
                        next = moment(`1/1/${Number(this.from.format('Y')) + 1}`, 'DD/MM/YYYY');
                    } else {
                        next = moment(`1/${Number(this.from.format('M')) + 1}/${this.from.year()}`, 'DD/MM/YYYY');
                    }
                    let tenure = Math.floor(this.to.diff(this.from, 'days') / 30);
                    let remainder = amount % tenure;
                    amount -= remainder;
                    amount = Number(amount) / Number(tenure);
                    for (let i = 0; i < tenure; i++) {
                        if (tenure - i === 1) {
                            this.installment.push({
                                amount: {
                                    amount: amount + remainder,
                                    currency_id: this.currentOrg.currency_id,
                                    currency_name: this.currentOrg.currency_name,
                                    currency_symbol: this.currentOrg.currency_symbol
                                },
                                due_date: next
                            });
                        } else {
                            this.installment.push({
                                amount: {
                                    amount: amount,
                                    currency_id: this.currentOrg.currency_id,
                                    currency_name: this.currentOrg.currency_name,
                                    currency_symbol: this.currentOrg.currency_symbol
                                },
                                due_date: next
                            });
                        }
                        if (Number(next.format('M')) === 12) {
                            next = moment(`1/1/${Number(next.format('Y')) + 1}`, 'DD/MM/YYYY');
                        } else {
                            next = moment(`1/${Number(next.format('M')) + 1}/${next.year()}`, 'DD/MM/YYYY');
                        }
                    }
                } else {
                    this.$toastr('error', 'Month Difference between this two date is less than one', 'Failed');
                }
            }
            /** If Frequency Type is QUARTERLY **/
            if (this.paymentTerm.frequency.id === 2) {
                let month_diff = Number(this.to.diff(this.from, "months"));
                if (month_diff > 3) {
                    let amount = this.paymentTerm.amount;
                    let next;
                    if (Number(this.from.format('M')) === 12) {
                        next = moment(`1/3/${Number(this.from.format('Y')) + 1}`, 'DD/MM/YYYY');
                    } else {
                        next = moment(`1/${Number(this.from.format('M')) + 3}/${this.from.year()}`, 'DD/MM/YYYY');
                    }
                    let tenure = Math.floor(this.to.diff(this.from, 'days') / 90);
                    let remainder = amount % tenure;
                    amount -= remainder;
                    amount = Number(amount) / Number(tenure);
                    for (let i = 0; i < tenure; i++) {
                        if (tenure - i === 1) {
                            this.installment.push({
                                amount: {
                                    amount: amount + remainder,
                                    currency_id: this.currentOrg.currency_id,
                                    currency_name: this.currentOrg.currency_name,
                                    currency_symbol: this.currentOrg.currency_symbol
                                },
                                due_date: next
                            });
                        } else {
                            this.installment.push({
                                amount: {
                                    amount: amount,
                                    currency_id: this.currentOrg.currency_id,
                                    currency_name: this.currentOrg.currency_name,
                                    currency_symbol: this.currentOrg.currency_symbol
                                },
                                due_date: next
                            });
                        }
                        if (Number(next.format('M')) === 12) {
                            next = moment(`1/3/${Number(next.format('Y')) + 1}`, 'DD/MM/YYYY');
                        } else {
                            next = moment(`1/${Number(next.format('M')) + 3}/${next.year()}`, 'DD/MM/YYYY');
                        }
                    }
                } else {
                    this.$toastr('error', 'Month Difference between this two date is less than three', 'Failed');
                }
            }
            /** If Frequency Type is YEARLY **/
            if (this.paymentTerm.frequency.id === 3) {
                let year_diff = Number(this.to.diff(this.from, "years"));
                if (year_diff > 0) {
                    let amount = this.paymentTerm.amount;
                    let next = moment(`1/1/${Number(this.from.format('Y')) + 1}}`, 'DD/MM/YYYY');
                    let tenure = Math.floor(this.to.diff(this.from, 'years'));
                    let remainder = amount % tenure;
                    amount -= remainder;
                    amount = Number(amount) / Number(tenure);
                    for (let i = 0; i < tenure; i++) {
                        if (tenure - i === 1) {
                            this.installment.push({
                                amount: {
                                    amount: amount + remainder,
                                    currency_id: this.currentOrg.currency_id,
                                    currency_name: this.currentOrg.currency_name,
                                    currency_symbol: this.currentOrg.currency_symbol
                                },
                                due_date: next
                            });
                        } else {
                            this.installment.push({
                                amount: {
                                    amount: amount,
                                    currency_id: this.currentOrg.currency_id,
                                    currency_name: this.currentOrg.currency_name,
                                    currency_symbol: this.currentOrg.currency_symbol
                                },
                                due_date: next
                            });
                        }
                        next = moment(`1/1/${Number(next.format('Y')) + 1}`, 'DD/MM/YYYY');
                    }
                } else {
                    this.$toastr('error', 'Year Difference between this two date is less than one', 'Failed');
                }
            }
        },
        addPaymentTerm() {
            let payment_term_amount = {
                amount: this.paymentTerm.amount,
                currency_id: this.currentOrg.currency_id,
                currency_name: this.currentOrg.currency_name,
                currency_symbol: this.currentOrg.currency_symbol
            };
            console.log("LOL", payment_term_amount, this.contract.amount);
            if (this.contract.paymentTerms.length === 0 && new Money(payment_term_amount).gt(new Money(this.contract.amount))) {
                this.$toastr('error', 'The added amount is greater than contract amount', 'Failed');
                return;
            }
            if (this.contract.paymentTerms.length > 0 && new Money(this.calculateAddedPaymentTerm(this.contract.paymentTerms, payment_term_amount)).gt(new Money(this.contract.amount))) {
                this.$toastr('error', 'The sum of added amounts is greater than contract amount', 'Failed');
                return;
            }
            if (!this.calculated) {
                this.from = moment(this.paymentTerm.issue_date, 'DD/MM/YYYY');
                this.to = moment(this.paymentTerm.due_date, 'DD/MM/YYYY');
            }
            let no_of_emi = 0;

            if (this.paymentTerm.method.id === 2) {
                if (this.paymentTerm.frequency.id === 1) {
                    no_of_emi = Math.floor(this.to.diff(this.from, 'days') / 30);
                    let month_diff = Number(this.to.diff(this.from, "months"));
                    if (month_diff < 1) {
                        this.$toastr('error', 'Month Difference between this two date is less than one', 'Failed');
                        return;
                    }
                } else if (this.paymentTerm.frequency.id === 2) {
                    no_of_emi = Math.floor(this.to.diff(this.from, 'days') / 90);
                    let month_diff = Number(this.to.diff(this.from, "months"));
                    if (month_diff < 3) {
                        this.$toastr('error', 'Month Difference between this two date is less than three', 'Failed');
                        return;
                    }
                } else if (this.paymentTerm.frequency.id === 3) {
                    no_of_emi = Math.floor(this.to.diff(this.from, 'years'));
                    let year_diff = Number(this.to.diff(this.from, "years"));
                    if (year_diff < 1) {
                        this.$toastr('error', 'Year Difference between this two date is less than one', 'Failed');
                        return;
                    }
                }
            }

            this.contract.paymentTerms.push({
                type: this.paymentTerm.method,
                amount: payment_term_amount,
                effective_from: this.issue_date,
                due_at: this.due_date,
                frequency: this.paymentTerm.frequency,
                no_of_emi: no_of_emi
            });
            this.contract.due = {
                amount: Number(this.contract.amount.amount) - Number(this.calculateAddedPaymentTerm(this.contract.paymentTerms, {amount: 0}).amount),
                currency_id: this.currentOrg.currency_id,
                currency_name: this.currentOrg.currency_name,
                currency_symbol: this.currentOrg.currency_symbol
            };
            this.reset();
            $("#myModal").modal('toggle');
            this.$toastr('success', 'The Payment Term is successfully added', 'Success');
        },
        setRemoveIndex(index) {
            this.removeIndex = index
        },
        removePaymentTerm(index) {
            this.contract.paymentTerms.splice(index, 1);
            this.contract.due = {
                amount: Number(this.contract.amount.amount) - Number(this.calculateAddedPaymentTerm(this.contract.paymentTerms, {amount: 0}).amount),
                currency_id: this.currentOrg.currency_id,
                currency_name: this.currentOrg.currency_name,
                currency_symbol: this.currentOrg.currency_symbol
            };
        },
        calculateAddedPaymentTerm(paymentTerms, newAmount) {
            let addedAmount = 0;
            paymentTerms.forEach(pt => {
                addedAmount = Number(addedAmount) + Number(pt.amount.amount);
            });
            return {
                amount: Number(addedAmount) + Number(newAmount.amount),
                currency_id: this.currentOrg.currency_id,
                currency_name: this.currentOrg.currency_name,
                currency_symbol: this.currentOrg.currency_symbol
            }
        },
        reset() {
            this.selectedPaymentMethod = null;
            this.paymentTerm.method = null;
            this.paymentTerm.amount = null;
            this.issue_date = null;
            this.paymentTerm.issue_date = null;
            this.due_date = null;
            this.paymentTerm.due_date = null;
            this.paymentTerm.frequency = null;
            this.installment = [];
        }
    }
}
</script>

<style scoped>

</style>
